// extracted by mini-css-extract-plugin
export default {"header":"Header_header__QJfsy","navbar":"Header_navbar__pYiIw"};